import React from 'react';
import { Route, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';
import MainWrapper from './MainWrapper';
import WrappedRoutes from './WrappedRoutes';

const Router = ({
 isAdmin, clientId, isVisitor, promotionId,
}) => (
  <MainWrapper>
    <main>
      <Switch>
        <Route path="/">
          <WrappedRoutes isAdmin={isAdmin} isVisitor={isVisitor} clientId={clientId} promotionId={promotionId} />
        </Route>
      </Switch>
    </main>
  </MainWrapper>
  );

Router.propTypes = {
  isAdmin: PropTypes.bool.isRequired,
  isVisitor: PropTypes.bool.isRequired,
  clientId: PropTypes.string.isRequired,
  promotionId: PropTypes.string.isRequired,
};

export default Router;
